import React from 'react';
import {
    ALLOCATION_REQUEST_FORM,
    FORM_FIELD_DESCRIPTION,
    FORM_FIELD_LINE,
    FORM_FIELD_ORDER,
    FORM_FIELD_PART_NO,
    FORM_FIELD_PROD,
    FORM_FIELD_QUANTITY,
    FORM_FIELD_REMARKS,
    FORM_LABEL_DESCRIPTION,
    FORM_LABEL_LINE,
    FORM_LABEL_ORDER,
    FORM_LABEL_PART_NO,
    FORM_LABEL_PROD,
    FORM_LABEL_QUANTITY,
    FORM_LABEL_REMARKS,
    FORM_LABEL_VOR_TRANSFER,
} from "../../../../../../constants/formConstants";
import {
    StyledSpan,
    StyledTh,
    StyledThead,
    StyledToolsTh,
} from "../../../../../common/StyledComponents";
import ValidFormattedMessage from "../../../../../common/ValidFormattedMessage";
import formMessages from "../../../../../../intl/sparePartsOrders/formMessages";
import PropTypes from 'prop-types';

const OrdersTableHeader = (props) => {
    const {userRights, readOnly, form, reqFields} = props;
    return (
        <StyledThead>
            <tr>
                {userRights.canTipOverToPvi && readOnly && form === ALLOCATION_REQUEST_FORM &&
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_VOR_TRANSFER} intlMessages={formMessages}/>
                </StyledTh>}
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_PROD} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_PROD) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_ORDER} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_ORDER) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_LINE} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_LINE) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_PART_NO} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_PART_NO) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_DESCRIPTION} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_DESCRIPTION) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_QUANTITY} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_QUANTITY) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                <StyledTh>
                    <ValidFormattedMessage message={FORM_LABEL_REMARKS} intlMessages={formMessages}/>
                    {reqFields.includes(FORM_FIELD_REMARKS) && !readOnly && <StyledSpan>{'\u00A0*'}</StyledSpan>}
                </StyledTh>
                {userRights.canEditItems && !readOnly && <StyledToolsTh/>}
            </tr>
        </StyledThead>
    )
}

OrdersTableHeader.propTypes = {
    readOnly: PropTypes.bool,
    form: PropTypes.string.isRequired,
    userRights: PropTypes.object.isRequired,
    reqFields: PropTypes.array.isRequired,
};

export default OrdersTableHeader;
